<div *ngIf="data" class="detail-content">
    <mat-form-field class="example-full-width">
        <mat-label>Terms Header</mat-label>
        <input matInput placeholder="Description"[(ngModel)]="data.termsHeader">
    </mat-form-field>
    <mat-form-field class="example-full-width">
        <mat-label>Terms Text</mat-label>
        <textarea  matInput placeholder="Description"[(ngModel)]="data.termsText" rows="24"></textarea>
    </mat-form-field>
</div>
